export default __webpack_public_path__ + "static/oaks-6b81d803eb74526bd711c2d4972d280e.jpg";